// @flow
import React from 'react';

import { FormFeedback } from 'Components/frameworks/form-feedback/FormFeedback.jsx';

type Props = {
  className?: string,
  texts: Array<string>,
  dataTestId?: string,
};

export function FormErrors({ className, texts = [], dataTestId }: Props) {
  return (
    <div className={className} data-testid={dataTestId}>
      {texts.map(text => (
        <FormFeedback key={text} isError message={text} />
      ))}
    </div>
  );
}
